import { render, staticRenderFns } from "./userBalance.vue?vue&type=template&id=0ceeafb4&scoped=true&"
import script from "./userBalance.vue?vue&type=script&lang=js&"
export * from "./userBalance.vue?vue&type=script&lang=js&"
import style0 from "./userBalance.vue?vue&type=style&index=0&id=0ceeafb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ceeafb4",
  null
  
)

export default component.exports